import NewMultiValue from './NewMultiValue';

export default NewMultiValue;
